import { isEmpty } from "../libs/validation/validators";


var store = {
    api: {
        getJSON: function (storeKey) {
            if (typeof localStorage !== 'undefined' && typeof localStorage !== "null") {
                var jsonStr = localStorage.getItem(storeKey);
                if (!isEmpty(jsonStr)) {
                    return JSON.parse(jsonStr);
                }
            }
            return null;
        },
        setJSON: function (storeKey, data) {
            if (typeof localStorage !== 'undefined') {
                localStorage.setItem(storeKey, JSON.stringify(data));
            }
        },
        clearItem: function (storeKey) {
            if (typeof localStorage !== 'undefined') {
                localStorage.removeItem(storeKey);
            }
        },
        clearStore: function () {
            Object.keys(store.data).map(key => { store.clearItem(key) });
        }
    },
    data: {
        OTPData: "OTPData",
        USERDATA: "userData",
        QuestionData: "questionData",
    }
}

export default store;
